<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {calcExtraServicesTotalPrice, calcTotalPrice} from '@/utils/price-utils'

    @Component
    export class OrderSummaryMixin extends Vue {
        //TODO Need total price calc global refactoring, now it is workaround for current order summary component solution
        get totalPrice() {
            if (this.prebooked) return this.orderTotalPrice
            let priceWithExtensions = {}
            const {price, supplierPrice} = this.extraServicesTotalPrice

            if (this.productStore?.seats) {
                const seatsTotalPrice = this.seatsTotalPrice
                if (seatsTotalPrice?.amount) {
                    const {amount, currency, originalAmount, originalCurrency} = this.orderTotalPrice
                    priceWithExtensions = calcTotalPrice([
                        {amount, currency, originalAmount, originalCurrency},
                        seatsTotalPrice,
                    ])
                    priceWithExtensions.originalCurrency = priceWithExtensions.currency
                    priceWithExtensions.originalAmount = priceWithExtensions.amount
                }
            }

            let totalPrice = {
                ...this.orderTotalPrice,
                ...priceWithExtensions,
            }

            if (!price || this.prebooked) return totalPrice
            const {amount, currency, originalAmount, originalCurrency} = totalPrice
            if (!price.originalCurrency) {
                price.originalCurrency = price.currency
                price.originalAmount = price.amount
            }
            priceWithExtensions = calcTotalPrice([{amount, currency, originalAmount, originalCurrency}, price])
            if (!priceWithExtensions.originalCurrency) {
                priceWithExtensions.originalCurrency = priceWithExtensions.currency
                priceWithExtensions.originalAmount = priceWithExtensions.amount
            }
            totalPrice = {
                ...clone(totalPrice),
                ...priceWithExtensions,
            }
            if (!supplierPrice) return totalPrice
            if (!supplierPrice.originalCurrency) {
                supplierPrice.originalCurrency = supplierPrice.currency
                supplierPrice.originalAmount = supplierPrice.amount
            }
            const {amount: supplierPriceAmount, originalAmount: supplierPriceOriginalCurrencyAmount} = calcTotalPrice([
                {
                    amount: this.orderTotalPrice.supplierPriceAmount,
                    currency,
                    originalAmount: this.orderTotalPrice.supplierPriceOriginalCurrencyAmount,
                    originalCurrency,
                },
                supplierPrice,
            ])
            return {
                ...totalPrice,
                ...{
                    supplierPriceAmount,
                    supplierPriceOriginalCurrencyAmount: supplierPriceOriginalCurrencyAmount || supplierPriceAmount,
                },
            }
        }

        get extraPrices() {
            if (!this.extraServices) return [{}]
            return [calcExtraServicesTotalPrice(this.additionalOptions, this.extraServices)]
        }

        get extraServicesTotalPrice() {
            return {
                price: calcTotalPrice([...this.extraPrices.map(({price}) => price).filter(Boolean)]),
                supplierPrice: calcTotalPrice([
                    ...this.extraPrices.map(({supplierPrice}) => supplierPrice).filter(Boolean),
                ]),
            }
        }

        get seatsTotalPrice() {
            const totalPrices = []
            this.productStore?.seats?.forEach((seats, index) => {
                if (seats.length) {
                    totalPrices.push(this.totalSeatPrice(seats.length, index))
                }
            })
            if (totalPrices.length > 1) {
                const {amount, currency, originalAmount, originalCurrency} = totalPrices[0]
                const totalPrice = calcTotalPrice([
                    {amount, currency, originalAmount, originalCurrency},
                    totalPrices[1],
                ])
                return {
                    ...totalPrice,
                    originalAmount: totalPrice.price,
                    originalCurrency: totalPrice.currency,
                }
            } else return totalPrices[0]
        }

        seatsPrice(priceIndex) {
            if (Array.isArray(this.additionalOptions)) {
                return this.additionalOptions?.[priceIndex]?.seatSelectionServices?.[0]?.price
            }
            return this.additionalOptions?.seatSelectionServices?.[0]?.price
        }

        totalSeatPrice(seatsCount, priceIndex) {
            const price = this.seatsPrice(priceIndex)
            if (price?.amount) {
                let seatPrice = clone(price)
                seatPrice.amount = seatPrice.amount * seatsCount
                return seatPrice
            }
            return {}
        }
    }

    export default OrderSummaryMixin
</script>
